import { render } from "./HeroSection.vue?vue&type=template&id=0880cc71&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=0880cc71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0880cc71"]])

export default __exports__